module.exports = {
      id: "device-usage",
      viewBox: "0 0 11 18",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#device-usage",
      toString: function () {
        return this.url;
      }
    }